const removeLastTwoDigits = (number) => {
  const numberStr = number.toString();
  const truncatedStr = numberStr.slice(0, -2);
  return Number(truncatedStr);
};

export default removeLastTwoDigits;
